import { Component, Input, OnInit } from '@angular/core';
import { getSubTags, hasTag, loadTags } from '../../util/tag-utils';
import { IConditionalSection } from '../models/condition-section.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditTagsComponent } from '../edit-tags/edit-tags.component';
import { Business } from '../../business/models/business.model';
import { BusinessManagerService } from '../../shared/user/business-manager.service';


@Component({
  selector: 'app-rental-cars',
  templateUrl: './rental-cars.component.html',
  styleUrls: ['./rental-cars.component.scss']
})
export class RentalCarsComponent implements IConditionalSection, OnInit {
  @Input() business: Business;
  hasTag = hasTag;
  editModeSet = false;
  _rentalCarTags: String[] = [];
  isRegionalManager = false;


  constructor(private _editCommunicationsDialog: MatDialog,
              private _toggleService: EditToggleService,
              public snackBar: MatSnackBar,
              private _editRentalCarsCheckboxDialog: MatDialog,
              private _businessManagerService: BusinessManagerService) { }

  async ngOnInit() {
    this._rentalCarTags = loadTags(this.business.tags,  'Rental Car::', '', '');
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
    this.isRegionalManager = await this._businessManagerService.isRegionalManager()
      && !await this._businessManagerService.userOwnsBusiness(this.business.id);
  }

  get hasContent(): boolean {
    return getSubTags(this.business.tags, 'Rental Car::').length > 0;
  }

  // For Now 10/30/18, Enterprise is the only rental car company that we show the logo for,
  // we will eventually change that and all logos to be displayed
  // get nonEnterpriseRentalCars(): String[] {
  //   const result: String[] = [];
  //   for (const currentTag of this.business.tags) {
  //     if (currentTag.tagName.startsWith('Rental Car::') &&
  //       !currentTag.tagName.includes('Enterprise')) {
  //       result.push(currentTag.displayName);
  //     }
  //   }
  //   return result.sort();
  // }

  openEditRentalCarsDialog(group: String[], except: String[], title: string): void {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      business: this.business,
      tagsGroup: group,
      except: except,
      title: title
    };

    dialogConfig.width = '95%';
    const dialogRef = this._editRentalCarsCheckboxDialog.open(EditTagsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isSuccess) => {
      if (isSuccess) {
        this._rentalCarTags = loadTags(this.business.tags,  'Rental Car::', '', '');
      } else {
        this.snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
